export const RECIPIENT_LABELS = {
  all: 'Все пользователи',
  start_registered: 'Зарегистрированы на старт',
  start_paid: 'Оплатили слот',
  start_participated: 'Участвовали в старте',
  filter: 'По выборке',
  user_ids: 'По списку ID или ФИО',
}

export const RECIPIENT_OPTIONS = [
  { value: 'all', label: 'Всем пользователям', hint: 'Все зарегистрированные пользователи с ролью «user»' },
  { value: 'start_registered', label: 'Зарегистрированы на старт', hint: 'Пользователи с регистрацией на выбранный старт' },
  { value: 'start_paid', label: 'Оплатили слот', hint: 'Только с успешной оплатой регистрации' },
  { value: 'start_participated', label: 'Участвовали в старте', hint: 'Пользователи с заполненными участниками в регистрации' },
  { value: 'filter', label: 'По выборке', hint: 'Фильтр по профилю, оплате или отзывам' },
  { value: 'user_ids', label: 'По списку ID или ФИО', hint: 'Поиск и выбор пользователей из выпадающего списка' },
]

export const FILTER_OPTIONS = [
  { value: 'incomplete_profile', text: 'Не заполнен профиль' },
  { value: 'no_phone', text: 'Без телефона' },
  { value: 'unpaid_registration', text: 'Не оплатили регистрацию' },
  { value: 'no_review', text: 'Не оставили отзыв после старта' },
]

export const EVENT_TYPE_OPTIONS = [
  { value: null, text: '— Только ручная отправка —' },
  { value: 'start_review_request', text: 'Старт завершён (после end_date)' },
  { value: 'start_reminder', text: 'Напоминание за день до старта' },
]

/** Подсказки в админке: какие типы шаблонов отправляются автоматически */
export const AUTO_TEMPLATE_KIND_DESCRIPTIONS = {
  start_completed:
    'Автоматически после окончания старта (когда наступило end_date). Получатели: участники без отзыва.',
  start_reminder:
    'Автоматически за день до старта. Получатели: все зарегистрированные на этот старт.',
}

export function templateKindAutoDescription(kind) {
  return AUTO_TEMPLATE_KIND_DESCRIPTIONS[kind] || null
}

export const TEMPLATE_KIND_OPTIONS = [
  { value: 'participant_data', text: 'Заполните данные участника', icon: 'UserIcon' },
  { value: 'start_completed', text: 'Старт завершён', icon: 'FlagIcon' },
  { value: 'results_published', text: 'Результаты опубликованы', icon: 'BarChart2Icon' },
  { value: 'organizer_message', text: 'Сообщение от организатора', icon: 'MailIcon' },
  { value: 'start_reminder', text: 'Напоминание о старте', icon: 'ClockIcon' },
  { value: 'account_security', text: 'Безопасность аккаунта', icon: 'ShieldIcon' },
  { value: 'default', text: 'Универсальное уведомление', icon: 'BellIcon' },
]

export const TEMPLATE_KIND_LABELS = TEMPLATE_KIND_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.text
  return acc
}, {})

export const TEMPLATE_KIND_ICONS = TEMPLATE_KIND_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.icon
  return acc
}, {})

export const TEMPLATE_KINDS_REQUIRING_START = [
  'participant_data',
  'start_completed',
  'results_published',
  'start_reminder',
  'organizer_message',
]

export function templateKindRequiresStart(kind) {
  return TEMPLATE_KINDS_REQUIRING_START.includes(kind)
}
